import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { CompanyDto } from '../types/dtos';

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.mutation<void, CompanyDto>({
        query: (payload) => ({
            url: APP_ENDPOINTS.COMPANIES,
            method: 'POST',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'companies-with-join', id: 'GET-JOIN' },
            { type: 'companies', id: 'GET' },
            { type: 'company-owners', id: 'GET' },
            { type: 'company-owners-with-join', id: 'GET-JOIN' },
        ],
    });
